import React from 'react';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './Title.module.scss';

const Title = ({ tag, img, text }) => (
  <div className={CN.component} data-bem="Title" data-tag={fromAnyToTrimmed(tag)}>
    <img src={img} className={CN.thumbnail} alt={text} />
    {text}
  </div>
);

export default Title;
